module.exports = __webpack_public_path__ + "static/media/legend.4cef1c5a.svg";